<template>
    <div>
        <div class="field">
            <label class="label">{{ $t('categories.choice_help_description') }}</label>
            <div class="field-control">
                <redactor :placeholder="$t('categories.choice_help_description')"
                                id="description"
                                v-model="category.choice_help_description"
                                :config="redactorConfig" />
            </div>
        </div>
        <div class="field">
            <label class="label">{{ $t('categories.choice_help_question') }}</label>
            <div class="field-control">
                <multiselect v-model="category.choice_help_question"
                             :options="questions"
                             label="name"
                             track-by="id"
                             :close-on-select="true"
                             :taggable="true"
                             placeholder=""
                             :multiple=false />
            </div>
        </div>
        <div @click="category.choice_assist_show_menu = !category.choice_assist_show_menu" class="field field--checkbox">
            <input :checked="!!category.choice_assist_show_menu" type="checkbox" />
            <div class="field-control">
                <label>{{ $t('categories.choice_help_show_menu') }}</label>
            </div>
        </div>
        <div @click="category.choice_assist_show_page = !category.choice_assist_show_page" class="field field--checkbox">
            <input :checked="!!category.choice_assist_show_page" type="checkbox" />
            <div class="field-control">
                <label>{{ $t('categories.choice_help_show_page') }}</label>
            </div>
        </div>
        <div @click="category.choice_assist_show_choice_assist_page = !category.choice_assist_show_choice_assist_page" class="field field--checkbox">
            <input :checked="!!category.choice_assist_show_choice_assist_page" type="checkbox" />
            <div class="field-control">
                <label>{{ $t('categories.choice_help_show_choice_help_page') }}</label>
            </div>
        </div>
    </div>
</template>

<script>
    import multiselect from 'vue-multiselect'
    import { ChoiceHelpService } from '../../../services';
    import Redactor from '../../../components/redactor-text-area';  

    export default {
        components: {
            multiselect,
            Redactor,
        },
        data() {
            return {
                questions: [],
                redactorConfig: {
                    buttons: ['bold', 'html', 'lists', 'italic', 'link'],
                },
            }
        },
        props: {
            category: {
                required: true
            },
        },
        methods: {
            fetchQuestions() {
                ChoiceHelpService.all().then(response => {
                    this.questions = response.data;
                });
            },
        },
        mounted() {
            this.fetchQuestions();
        },
        name: "ChoiceHelpTab"
    }
</script>
